import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bbadca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "model-selector__title",
  style: {"float":"left"}
}, "Emergency Alert Details", -1))
const _hoisted_2 = { class: "row page-heading-container dt-flex" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  title: "This alert is currently being displayed to targetted rooms and/or locations",
  style: {"cursor":"default","color":"green","font-weight":"bold","text-align":"right","float":"right","font-size":"1.5em","letter-spacing":"4px","position":"relative","right":"25px"}
}, "ACTIVE", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  title: "This alert is not being displayed",
  style: {"cursor":"default","color":"lightgray","font-weight":"bold","text-align":"right","float":"right","font-size":"1.5em","letter-spacing":"4px","position":"relative","right":"25px"}
}, "INACTIVE", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "dt-card__body" }
const _hoisted_11 = { class: "Alert-MoreInfo-container p-4" }
const _hoisted_12 = { class: "row page-heading-container" }
const _hoisted_13 = { class: "text-left dt-flex flex-row" }
const _hoisted_14 = { class: "dt-half" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Identifier:", -1))
const _hoisted_16 = { class: "dt-half" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Alert Type:", -1))
const _hoisted_18 = { class: "row page-heading-container" }
const _hoisted_19 = { class: "text-left dt-flex flex-row" }
const _hoisted_20 = { class: "dt-half" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Category:", -1))
const _hoisted_22 = { class: "dt-half" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Currently Active:", -1))
const _hoisted_24 = { class: "text-left dt-flex flex-row" }
const _hoisted_25 = { class: "dt-half" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Event:", -1))
const _hoisted_27 = { class: "dt-half" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Title:", -1))
const _hoisted_29 = { class: "row page-heading-container" }
const _hoisted_30 = { class: "text-left dt-flex flex-row" }
const _hoisted_31 = { class: "dt-half" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Sender IP Address:", -1))
const _hoisted_33 = { class: "dt-half" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Sender:", -1))
const _hoisted_35 = { class: "text-left dt-flex flex-row" }
const _hoisted_36 = { class: "dt-half" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Response Type:", -1))
const _hoisted_38 = { class: "dt-half" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Scope:", -1))
const _hoisted_40 = { class: "row page-heading-container" }
const _hoisted_41 = { class: "text-left dt-flex flex-row" }
const _hoisted_42 = { class: "dt-half" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Description:", -1))
const _hoisted_44 = { class: "dt-half" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Instructions:", -1))
const _hoisted_46 = { class: "text-left dt-flex flex-row" }
const _hoisted_47 = { class: "dt-half" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Created (UTC):", -1))
const _hoisted_49 = { class: "dt-half" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Updated (UTC):", -1))
const _hoisted_51 = { class: "row page-heading-container" }
const _hoisted_52 = { class: "text-left dt-flex flex-row" }
const _hoisted_53 = { class: "dt-half" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Expiration (UTC):", -1))
const _hoisted_55 = { class: "dt-half" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Certainty:", -1))
const _hoisted_57 = { class: "text-left dt-flex flex-row" }
const _hoisted_58 = { class: "dt-half" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Urgency:", -1))
const _hoisted_60 = { class: "dt-half" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Severity:", -1))
const _hoisted_62 = { class: "row page-heading-container" }
const _hoisted_63 = { class: "text-left dt-flex flex-row" }
const _hoisted_64 = { class: "dt-half" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Incidents:", -1))
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { class: "dt-half" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "References:", -1))
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { class: "row page-heading-container" }
const _hoisted_73 = { class: "text-left dt-flex flex-row" }
const _hoisted_74 = { class: "dt-half" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Location Targeting:", -1))
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { if: "alertInfo && alertInfo.areaCircle && Array.isArray(alertInfo.areaCircle) == true && alertInfo.areaCircle.length > 0" }
const _hoisted_78 = { if: "alertInfo && alertInfo.areaPolygon && Array.isArray(alertInfo.areaPolygon) == true && alertInfo.areaPolygon.length > 0" }
const _hoisted_79 = { class: "dt-half" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Language:", -1))
const _hoisted_81 = { class: "row page-heading-container" }
const _hoisted_82 = { class: "text-left dt-flex flex-row" }
const _hoisted_83 = {
  class: "dt-half",
  style: {"word-break":"break-word","max-height":"350px","overflow":"scroll"}
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Skip Reasons:", -1))
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = {
  class: "dt-half",
  style: {"word-break":"break-word","max-height":"350px","overflow":"scroll"}
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Activate Reasons:", -1))
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { class: "row page-heading-container" }
const _hoisted_92 = { class: "text-left dt-flex flex-row" }
const _hoisted_93 = {
  class: "dt-half",
  style: {"word-break":"break-word","max-height":"350px","overflow":"scroll"}
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Deactivate Reasons:", -1))
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_selection = _resolveComponent("selection")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "el-dialog--large modal-selector-dialog",
    "before-close": _ctx.handleClose
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.alertInfo && _ctx.alertInfo.is_active)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.alertInfo && !_ctx.alertInfo.is_active)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_selection, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.identifier), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.msgType), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.category), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.is_active), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.event), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.title), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.ipAddress), 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.sender), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.responseType), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.scope), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.description), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.instruction), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDateToDisplayInUTC(new Date(_ctx.alertInfo.createdAt))), 1)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDateToDisplayInUTC(new Date(_ctx.alertInfo.updatedAt))), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDateToDisplayInUTC(new Date(_ctx.alertInfo.expirationTime))), 1)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.certainty), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.urgency), 1)
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.severity), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    (_ctx.alertInfo && _ctx.alertInfo.incidents && _ctx.alertInfo.incidents.length == 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_66, " None"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_67, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertInfo.incidents, (incident) => {
                            return (_openBlock(), _createElementBlock("ul", { key: incident }, [
                              _createElementVNode("li", null, _toDisplayString(incident), 1)
                            ]))
                          }), 128))
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _hoisted_69,
                    (_ctx.alertInfo && _ctx.alertInfo.references && _ctx.alertInfo.references.length == 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_70, " None"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_71, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertInfo.references, (reference) => {
                            return (_openBlock(), _createElementBlock("ul", { key: reference }, [
                              _createElementVNode("li", null, _toDisplayString(reference), 1)
                            ]))
                          }), 128))
                        ]))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    (_ctx.alertInfo && !_ctx.alertInfo.areaCircle && (_ctx.alertInfo.areaPolygon && !_ctx.alertInfo.areaPolygon.length))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_76, " None "))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_77, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertInfo.areaCircle, (areaCircle) => {
                        return (_openBlock(), _createElementBlock("span", { key: areaCircle }, _toDisplayString(areaCircle.split(' ')[1]) + " kilometers from " + _toDisplayString(areaCircle.split(' ')[0]), 1))
                      }), 128))
                    ]),
                    _createElementVNode("ul", _hoisted_78, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertInfo.alertInfo, (polygonItem) => {
                        return (_openBlock(), _createElementBlock("li", { key: polygonItem }, _toDisplayString(polygonItem), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _hoisted_80,
                    _createTextVNode(" " + _toDisplayString(_ctx.alertInfo.language), 1)
                  ])
                ])
              ]),
              _createVNode(_component_el_divider),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _hoisted_84,
                    (_ctx.alertInfo && _ctx.alertInfo.skipReason && _ctx.alertInfo.skipReason.length == 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_85, " None"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_86, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertInfo.skipReason, (skipReason) => {
                            return (_openBlock(), _createElementBlock("ul", { key: skipReason }, [
                              _createElementVNode("li", null, _toDisplayString(skipReason), 1)
                            ]))
                          }), 128))
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _hoisted_88,
                    (_ctx.alertInfo && _ctx.alertInfo.activateReason && _ctx.alertInfo.activateReason.length == 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_89, " None"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_90, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertInfo.activateReason, (activateReason) => {
                            return (_openBlock(), _createElementBlock("ul", { key: activateReason }, [
                              _createElementVNode("li", null, _toDisplayString(activateReason), 1)
                            ]))
                          }), 128))
                        ]))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _hoisted_94,
                    (_ctx.alertInfo && ((_ctx.alertInfo.deactivateReason && _ctx.alertInfo.deactivateReason.length == 0) || !_ctx.alertInfo.deactivateReason))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_95, " None"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_96, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertInfo.deactivateReason, (deactivateReason) => {
                            return (_openBlock(), _createElementBlock("ul", { key: deactivateReason }, [
                              _createElementVNode("li", null, _toDisplayString(deactivateReason), 1)
                            ]))
                          }), 128))
                        ]))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["before-close"]))
}